import '../../styles/generic.css';
import '../../styles/solutions.css';

import { _ } from '../../utils/l10n';

export const ComingSoonTag = () => <span className="mono-space-text coming-soon-tag">{_('Coming Soon')}</span>;
